module.exports = __webpack_public_path__ + "static/media/kudu1.4bf9ba0a.mp4";